import { FeatureFlags } from "@/features/feature-flags";
import { verifyRoles } from "@/utils/verifyRoles";
import { createFileRoute } from "@tanstack/react-router";
import { isomorphicHttpClient } from "../../../../../httpClient";

export const Route = createFileRoute(
  "/dashboard/tenants/$tenantId/feature-flags/",
)({
  component: FeatureFlags,
  head: () => ({
    meta: [{ title: "Feature flags - Backoffice Detentora Iniciador" }],
  }),
  beforeLoad: () => verifyRoles(["INIC_ADMIN"]),
  loader: async ({ context, params }) => {
    const tenantId = decodeURIComponent(params.tenantId);

    await context.queryClient.prefetchQuery({
      queryKey: ["feature-flags", tenantId],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET(
          "/v1/feature-flags/{tenantId}",
          {
            params: { path: { tenantId } },
          },
        );

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });

    await context.queryClient.prefetchQuery({
      queryKey: ["tenant", tenantId],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET("/v1/tenants/{tenantId}", {
          params: { path: { tenantId } },
        });

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
